import { render, staticRenderFns } from "./ExactConnectRedirect.vue?vue&type=template&id=20bc5da1"
import script from "./ExactConnectRedirect.vue?vue&type=script&lang=ts"
export * from "./ExactConnectRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20bc5da1')) {
      api.createRecord('20bc5da1', component.options)
    } else {
      api.reload('20bc5da1', component.options)
    }
    module.hot.accept("./ExactConnectRedirect.vue?vue&type=template&id=20bc5da1", function () {
      api.rerender('20bc5da1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ExactConnectRedirect.vue"
export default component.exports